import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from 'antd';

import { Default } from '../../../../layouts';
import useDatasource from '../../../../hooks/useDatasource';
import PageTitle from '../../../../components/PageTitle';
import AddEntityButton from '../../../../components/buttons/AddEntityButton';
import DeleteItemIcon from '../../../../components/buttons/DeleteItemIcon';
import EditItemIcon from '../../../../components/buttons/EditItemIcon';
import Column from '../../../../helpers/columns';
import {
  deleteSchedule,
  getSchedules,
} from '../../../../services/offers/schedules';
import usePermissions from '../../../../hooks/usePermission';
import ViewItemIcon from '../../../../components/buttons/ViewItemIcon';

const permissionsMap = {
  canView: ['ADMINISTRATION_OFFERS_VIEW_PERMISSION'],
  canEdit: ['SYS_SUPERUSER', 'OFFERS_PERMISSION'],
  canDelete: ['SYS_SUPERUSER', 'OFFERS_PERMISSION'],
};

const SchedulesList = () => {
  const { t } = useTranslation();
  const { canView, canEdit, canDelete } = usePermissions(permissionsMap);
  const { pagination, content, handleChange, reload } =
    useDatasource(getSchedules);

  const columns = useMemo(
    () => [
      Column.text('name', t('entity.offers.schedule.name'), { filter: true }),
      Column.bool('deleted', t('common.deleted._'), {
        filter: true,
        inverted: true,
        labels: [
          t('table.filter.all'),
          t('common.deleted.true'),
          t('common.deleted.false'),
          t('table.filter.unknown'),
        ],
      }),

      Column.actions(t('table.actions'), (schedule) => (
        <>
          {canView && (
            <ViewItemIcon path={`/admin/offers/schedules/${schedule.id}`} />
          )}
          {canEdit && (
            <EditItemIcon path={`/admin/offers/schedules/${schedule.id}`} />
          )}
          {canDelete && (
            <DeleteItemIcon
              title={t('entity.offers.schedule._delete', schedule)}
              message={t('entity.offers.schedule._deleted', schedule)}
              item={schedule}
              action={deleteSchedule}
              reload={reload}
            />
          )}
        </>
      )),
    ],
    [t, canView, canEdit, canDelete, reload],
  );

  return (
    <Default>
      <PageTitle title={t('entity.offers.schedule._plural')}>
        {canEdit && (
          <AddEntityButton
            entity={t('entity.offers.schedule._singular')}
            path="/admin/offers/schedules/new"
          />
        )}
      </PageTitle>
      <Table
        columns={columns}
        rowKey="id"
        // loading={loading}
        pagination={pagination}
        dataSource={content}
        onChange={handleChange}
        scroll={{ x: 700, y: 700 }}
      />
    </Default>
  );
};

export default SchedulesList;
